import React, {useState} from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "assets/css/MiniCalendar.css";
import {Box, Icon, Text} from "@chakra-ui/react";
// Chakra imports
import {MdChevronLeft, MdChevronRight} from "react-icons/md";
// Custom components
import Card from "../card/Card.jsx";

export default function MiniCalendar(props) {
    const {selectRange, ...rest} = props;
    const [value, onChange] = useState(new Date());
    return (
        <Card
            align="center"
            direction="column"
            w="100%"
            maxW="max-content"
            p="20px 15px"
            h="max-content"
            {...rest}
        >
            <Box
                sx={{
                    '.react-calendar': {
                        border: 'none',
                        boxShadow: 'none', // if shadow is also present
                    },
                }}
            >
                <Calendar
                    onChange={onChange}
                    value={value}
                    selectRange={selectRange}
                    view="month"
                    tileContent={<Text color="brand.500"/>}
                    prevLabel={<Icon as={MdChevronLeft} w="24px" h="24px" mt="4px"/>}
                    nextLabel={<Icon as={MdChevronRight} w="24px" h="24px" mt="4px"/>}
                />
            </Box>
        </Card>
    );
}
